import { inheritActionOwner, isActionCurrent } from '@/_core/fluxstore/dispatchOwnership';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { FlashJustDragged, SetKeyOnNewCard } from '../..';
import { createNewCardCommand } from '../../../api/commands/factory/createNewCard';
import { Activity, StorymapState } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';
import { AddNewCardResult } from '../../../api/commands';
import { createDebugger } from '@/_core/utils/debug';

const debug = createDebugger('pages:main:storymap:store:actions:newCard:saveNewActivity');

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class SaveNewActivity extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SaveNewActivity';

    public _savedCard: Activity = null;

    public constructor(public cardId: string, public title: string) {
        super(SaveNewActivity.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SaveNewActivity): Promise<boolean> => {
    debug('SaveNewActivity.middleware', action);

    const card = getCardById(action.cardId);
    if (card) {
        card.isSaving = true;
    }

    if (!action.isDispatchedByRealTimeCallback) {
        dispatch(inheritActionOwner(action, new FlashJustDragged()));
    }

    const command = action.isDispatchedByRealTimeCallback ? null : await createNewCardCommand(action);
    if (!isActionCurrent(action)) return false;
    await useSendCommandAsync(action, {
        isCurrent: () => isActionCurrent(action),
        createCommand: async () => command,
        onSuccess: (res: AddNewCardResult) => {
            if (!isActionCurrent(action)) return;
            debug('setkeyonnewcard', res, action);
            dispatch(inheritActionOwner(action, new SetKeyOnNewCard(action.cardId, res.CardKey)));
        },
    });

    if (!isActionCurrent(action)) return false;
    if (!action.isDispatchedByRealTimeCallback) {
        action._savedCard = state.activities.find((x) => x.id == action.cardId);
    }

    debug('SaveNewActivity.middleware end', action);

    return true;
};

const reducer = (state: StorymapState, action: SaveNewActivity): void => {
    if (action.isDispatchedByRealTimeCallback) {
        state.activities.filter((x) => x.order >= action._savedCard.order).forEach((x) => x.order++);
        state.activities.push(action._savedCard);
    }

    const card = getCardById(action.cardId);
    card.title = action.title;
    card.color = state.activityColor;

    card.isNew = false;
    card.isSaving = false;

    if (action.isDispatchedByRealTimeCallback) {
        card.isActive = false;
    }
};

//@ts-ignore
registerMiddleware(SaveNewActivity.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SaveNewActivity.ACTION_TYPE, reducer);
